import { render, staticRenderFns } from "./MusicControl-v1.vue?vue&type=template&id=12fdcbf8&scoped=true"
import script from "./MusicControl-v1.vue?vue&type=script&lang=js"
export * from "./MusicControl-v1.vue?vue&type=script&lang=js"
import style0 from "./MusicControl-v1.vue?vue&type=style&index=0&id=12fdcbf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fdcbf8",
  null
  
)

export default component.exports